export const byId = id => document.getElementById(id);